import { ImportWizardQuarantinedDrugListComponent } from '../import-wizard-quarantined-drug-list/import-wizard-quarantined-drug-list.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import { Drug } from '../../models/drug';
import { RpoToolService } from '../../services/rpo-tool.service';
import * as constants from 'src/app/config/app-constants';
import { Router } from '@angular/router';
import { routePaths } from 'src/app/config/app-constants';
import { OpenEditWizardService } from '../../services/open-edit-wizard.service';
@Component({
    selector: 'app-new-drug-list',
    templateUrl: './new-drug-list.component.html',
    styleUrls: ['./new-drug-list.component.scss'],
    standalone: false
})
export class NewDrugListComponent implements OnInit {
  displayedColumns = ['name', 'ndc', 'countryCode','source', 'system', 'strength', 'manufacturer', 'priority', 'modifiedBy' ,'requestor', 'age','action'];
  selectedRow:any;
  @Input() dataSourceId: number;
  @Input() searchText: string;
  @Input() permanentQuarantine:boolean = false;
  @Input() countryId: number;
  @Input() selectedSearchCriteria: any;
  @Input() modifiedBy: string = null;
  dataSource= new MatTableDataSource<Drug>();
     //#region Pagination properties
     totalRows: number = 0;
     currentPage: number = 1;
     pageSize: number = 25;
     pageSizeOptions: number[] = [5, 10, 20, 40, 50];
     //#endregion
  constructor(
    private rpoService: RpoToolService,
    private dialog: MatDialog,
    private ngxLoader: NgxUiLoaderService,
    private route: Router,
    private toastService: ToastService,
    private openEditWizardService: OpenEditWizardService) { }

  ngOnInit(): void {
   this.getDrugData();
  }

  handleInputChange(dataSourceId:number,searchText:any, countryId:number, permanentQuarantine:boolean = false){
    this.dataSourceId=dataSourceId;
    this.searchText = searchText;
    this.countryId = countryId;
    this.permanentQuarantine = permanentQuarantine;
    if(this.searchText.length>0 || this.countryId>=0){
       // this.getDrugData();
    }


}

  getDrugData(){
    this.rpoService.getNewDrugHistory(
      this.dataSourceId,
      this.searchText,
      this.permanentQuarantine,
      this.countryId,
      this.currentPage,
      this.pageSize,
      this.selectedSearchCriteria,
      this.modifiedBy
    ).subscribe((result)=>{
     this.dataSource.data = result.data.drugs
     this.currentPage = result.data.currentPage
     this.totalRows = result.data.totalRows

    },
    (error: HttpErrorResponse) => {
      console.log(error);
      this.toastService.openToast(
        error.message,
        constants.ToastPanelType.error,
        2
      );

    })
  }


  openImportWizardQuanrantinedDrug() {

    const dialogRef = this.dialog.open(ImportWizardQuarantinedDrugListComponent, {
    backdropClass: ['lgDialog'],
    disableClose: true,
    data:{
      dataSourceId:this.dataSourceId,
      searchText: this.searchText,
      countryId:this.countryId,
      permanentQuarantine:this.permanentQuarantine,
      selectedSearchCriteria: this.selectedSearchCriteria
    }
    });

  }

  openDrugDetailsImportWizard(drugId:string, dataSourceId:number) {
    
    this.openEditWizardService.openDrugDetailsImportWizard(drugId,dataSourceId,'');
  }
}
